var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWeInfo02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9007 5.5492C14.8333 5.32635 13.8771 5.88605 13.4856 6.75419C13.3721 7.00593 13.0761 7.11799 12.8243 7.00448C12.5726 6.89097 12.4605 6.59489 12.574 6.34315C13.1497 5.06648 14.5584 4.24738 16.1051 4.57031C17.2845 4.81651 18.2298 5.75633 18.4875 6.92917C18.5108 7.03415 18.5277 7.14182 18.539 7.24216C18.7596 9.05079 17.2453 10.5483 15.4906 10.5483H3C2.72386 10.5483 2.5 10.3245 2.5 10.0483C2.5 9.77221 2.72386 9.54835 3 9.54835H15.4906C16.7129 9.54835 17.6874 8.51011 17.5461 7.36134L17.5454 7.35553L17.5454 7.35553C17.5375 7.28456 17.5259 7.2116 17.5112 7.14546L17.5109 7.1442C17.3376 6.35446 16.6935 5.71469 15.9007 5.5492L15.9007 5.5492Z",
    fill: "#62738F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.37207 15.1606C5.37207 14.8845 5.59593 14.6606 5.87207 14.6606H11.0522C12.3144 14.6606 13.4072 15.7405 13.254 17.0502C13.2472 17.1259 13.2345 17.2088 13.2147 17.29C13.0267 18.1356 12.3451 18.8082 11.4949 18.9869L11.4943 18.987C10.3829 19.219 9.36743 18.6293 8.94987 17.7082C8.83585 17.4567 8.94731 17.1604 9.19882 17.0464C9.45032 16.9323 9.74663 17.0438 9.86065 17.2953C10.0941 17.8103 10.6584 18.1398 11.2895 18.0082C11.7582 17.9096 12.138 17.5321 12.2394 17.0692L12.2427 17.0549C12.2497 17.027 12.2554 16.9918 12.2582 16.9575C12.2588 16.9513 12.2594 16.945 12.2602 16.9388C12.3401 16.2801 11.7786 15.6606 11.0522 15.6606H5.87207C5.59593 15.6606 5.37207 15.4368 5.37207 15.1606Z",
    fill: "#62738F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.44629 12.5906C8.44642 12.3144 8.67039 12.0907 8.94653 12.0908L18.7655 12.0956C18.7654 12.0956 18.7656 12.0956 18.7655 12.0956C20.9048 12.0957 22.7447 13.9308 22.4742 16.123L22.4737 16.1264C22.4575 16.2507 22.4359 16.3747 22.4091 16.4983L22.4087 16.5C22.0935 17.9268 20.9374 19.0721 19.5046 19.371C17.6212 19.7662 15.9075 18.7634 15.2031 17.2116C15.089 16.9601 15.2003 16.6638 15.4517 16.5496C15.7032 16.4355 15.9996 16.5468 16.1137 16.7983C16.6349 17.9465 17.8988 18.6863 19.2995 18.3923C20.3462 18.174 21.2013 17.3281 21.4321 16.2851C21.4528 16.1893 21.4694 16.0939 21.4819 15.9988C21.6698 14.4671 20.3693 13.0956 18.7655 13.0956L8.94605 13.0908C8.6699 13.0907 8.44615 12.8667 8.44629 12.5906Z",
    fill: "#62738F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5 12.5945C2.5 12.3183 2.72386 12.0945 3 12.0945H6.07359C6.34973 12.0945 6.57359 12.3183 6.57359 12.5945C6.57359 12.8706 6.34973 13.0945 6.07359 13.0945H3C2.72386 13.0945 2.5 12.8706 2.5 12.5945Z",
    fill: "#62738F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeInfo02);
export default __webpack_public_path__ + "static/media/we_info02.3c20d67a78f0762acc63bb668646cb01.svg";
export { ForwardRef as ReactComponent };